import type {BannerView} from './BannerView';

const POLL_TIMEOUT_MS = 100;
const MAX_POLLS = 15;

export type IHeightChangeHandler = () => unknown;

export interface IBannerHeightChangeWatcherSettings {
    bannerView: BannerView;
    /**
     * Обработчик изменения высоты.
     */
    onHeightChange?: IHeightChangeHandler | null;
}

export class BannerHeightChangeWatcher {
    bannerView: BannerView;
    running = false;
    height = 0;
    onHeightChange: IHeightChangeHandler | null;
    prevHeight = 0;
    count = 0;
    watcherTimeoutId: number | undefined;

    constructor(settings: IBannerHeightChangeWatcherSettings) {
        this.bannerView = settings.bannerView;
        this.onHeightChange = settings.onHeightChange || null;
    }

    start() {
        if (this.running) {
            return;
        }

        const container: HTMLElement = this.bannerView.container;

        this.count = 0;
        this.running = true;
        this.height = container.offsetHeight;
        this.prevHeight = this.height;

        this.watcherTimeoutId = window.setInterval(() => {
            const newHeight = container.offsetHeight;
            if (this.count < MAX_POLLS) {
                if (newHeight > 0 && newHeight !== this.height) {
                    this.prevHeight = this.height;
                    this.height = newHeight;
                    this.onHeightChange?.();
                }
                this.count++;
            } else {
                this.stop();
            }
        }, POLL_TIMEOUT_MS);
    }

    stop() {
        if (this.running) {
            clearInterval(this.watcherTimeoutId);
            this.running = false;
        }
    }
}
